import * as React from "react";

const CleaningAndJanitorialIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="92.92" height="75" viewBox="0 0 92.92 117.516">
            <g id="Group_2497" data-name="Group 2497" transform="translate(-913.54 -433.484)">
                <path
                    id="Path_4544"
                    data-name="Path 4544"
                    d="M79.13,12.608C71.173,4.242,60.181,0,46.46,0S21.747,4.242,13.79,12.608C1,26.052,0,45.855,0,51.738c0,.878.022,1.43.031,1.618v4.427h3.7V55.272h6.547c-.163-1.83-.4-4.541-.518-5.835H3.774c.334-7.251,2.289-23.349,12.713-34.3C23.717,7.55,33.8,3.7,46.46,3.7S69.2,7.55,76.433,15.141c10.424,10.947,12.381,27.045,12.713,34.3H83.159c-.116,1.294-.356,4-.519,5.835h6.548v2.511h3.7V53.356c.008-.189.03-.74.03-1.618,0-5.882-1-25.686-13.79-39.13"
                    transform="translate(913.54 433.484)"
                    fill="#fff"
                />
                <path
                    id="Path_4545"
                    data-name="Path 4545"
                    d="M90.337,75.883H13.054v2.135H16.69l.682,7.686H86.018l.683-7.686h3.636Z"
                    transform="translate(908.305 403.052)"
                />
                <path
                    id="Path_4546"
                    data-name="Path 4546"
                    d="M23.91,152.218c.259,1.8.519,3.544,2.032,3.544H83.45c1.513,0,1.774-1.747,2.033-3.544l3.373-56.85H20.538Z"
                    transform="translate(905.304 395.238)"
                />
            </g>
        </svg>
    );
};

export default React.memo(CleaningAndJanitorialIcon);
